define('Components/Comein/js/views/blocks/ComeinLoyaltyHistoryView',['backbone','app','template!Components/Comein/templates/loyalty','Components/Comein/js/models/CagnotteModel'],function(backbone, app, loyaltyTemplate, CagnotteModel){
    return Backbone.View.extend({

        displayAsModal: true,
        events:{
            'click .btn-close': 'clickClose',
        },

        clickClose: function ()
        {
            this.trigger('close', this);
        },
        initialize:function(){
            console.log('initialize Loyalty Comein profile view');
            var view = this;
            view.model = new CagnotteModel();

            this.render();
        },
        render:function(){
            this.$el.html(loyaltyTemplate(this.model));
        },
    });
});
